import React from "react";
import "../index.css";
import Coursemap from "./Coursemap";
// import UnitInformation from "./UnitInformation";

function SidePanel({ coursemapUnits, setCoursemapUnits }) {
  const year_semester = ["Y1S1", "Y1S2", "Y2S1", "Y2S2", "Y3S1", "Y3S2"];

  return (
    <>
      {/* <UnitInformation /> */}
      <Coursemap
        year_semester={year_semester}
        coursemapUnits={coursemapUnits}
        setCoursemapUnits={setCoursemapUnits}
      />
    </>
  );
}

export default SidePanel;
